import { makeDraggable, makeDroppable } from "./dragAndDropSupport.js";
import stacker, { verticalDirection } from "../elements/stacker/stacker.js";

/**
 * Make a simple renderer supporting drag and drop that will handle
 * the tag brushes.
 *
 * @param {function():object[]} getItems - Should return general
 *   models that will be sorted manually. They will define the
 *   argument of the onChange callback
 * @param {function(object):Renderable} [itemRenderer] - Takes an item
 *   as argument and should return a renderable. The default is to use
 *   the item itself as renderable
 * @param {function(object[]): void} [onChange] - Executed with the items as
 *   arguments in their visual specific order
 * @param {object} container - Binder of the items (usually the widget
 *   rendering the tag brushes) to allow the GC to free the bindings
 *   when the container is gone
 * @param {object} [options] - Passed to the stacker containing the
 *   items
 */
export default function makeDragAndDropRenderer({
	getItems,
	itemRenderer = (item) => item,
	onChange = (_items) => {},
	container,
	options = { direction: verticalDirection },
}) {
	return (html) => {
		stacker(
			options,
			getItems().map((item) => {
				const itemRenderable = html.div(itemRenderer(item));

				makeDroppable(itemRenderable, {
					item,
					container,
					onChange: ({ items }) => onChange(items),
				});

				return makeDraggable(itemRenderable);
			}),
		);
	};
}
